<template>
	<div>
		<div class="flex bg-white list-item margin-bottom-sm" @click="godetail(data)">
			<img class="cover margin-right-sm" :src="data.logo" >
			<div class="text-left flex flex-direction justify-between">
				<div class="titlw">{{data.title}}</div>
				<p class="text-sm text-666">课程章节：共{{data.chapterCount}}节</p>
				<div class="flex align-center justify-between">
					<p class="text-price text-bf text-bold text-prices">{{data.price}}</p>
					<p class="text-right text-sm text-ccc">{{data.type == 1?'文件课程':'视频课程'}}</p>
				</div>
			</div>
			<div v-if="data.is_resources == 1" class="status paied">已驳回</div>
			<div v-if="data.is_resources == 2" class="status paied">已通过</div>
			<div v-if="data.is_resources == 0" class="status paied">待审核</div>
			<div v-if="data.is_resources == 3" class="status paied">待提交</div>
		</div>
	</div>
</template>

<script>
	export default {
	  props: {
		size:{//标题字体
			type: [String,Number],
			default:18
		},
		type:{//1  免费    2   精品
			type: [String,Number],
			default:1
		},
		data: {
			type: Object,
			default: {}
		}
	  },
	  mounted(){
	    
	  },
	  methods: {
	    godetail(item){
	    	this.$emit('godetail',item)
			
	    }
	  }
	};
</script>

<style scoped lang="less">
	.list-item{
		padding: 20px;
		border-radius: 20px;
		width: 451px;
		position: relative;
		.status{
			position: absolute;
			top: 0;
			right: 0;
			width: 63px;
			height: 29px;
			line-height: 29px;
			border-radius: 0px 20px 0px 10px;
		}
		.paied{
			background: rgba(11,131,124,0.1000);
			color: #0B837C;
		}
	}
	.cover{
		width: 104px;
		height: 133px;
	}
	.titlw{
		width: 260px;
	}
</style>



// WEBPACK FOOTER //
// src/components/list/course-list.vue